import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OperacaoFinanceiraListarComponent } from './operacao-financeira-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: OperacaoFinanceiraListarComponent }
    ])],
    exports: [RouterModule]
})
export class OperacaoFinanceiraListarRoutingModule { }
